import {
  CircularProgress,
  CircularProgressProps,
  Box,
  BoxProps,
} from '@mui/material';

export interface LoaderProps extends CircularProgressProps {
  fullScreen?: boolean;
  containerProps?: BoxProps;
  message?: string;
}

export const Loader = ({
  fullScreen = false,
  containerProps,
  message,
  ...props
}: LoaderProps) => {
  const loader = (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
      {...(fullScreen && {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: 'rgba(255, 255, 255, 0.9)',
        zIndex: 9999,
      })}
      {...containerProps}
    >
      <CircularProgress {...props} />
      {message && <Box sx={{ mt: 2, color: 'text.secondary' }}>{message}</Box>}
    </Box>
  );

  return loader;
};

export default Loader;
